import { lastUtils } from '@last/core'

let gtm

async function load(googleTagManagerId, cookies) {
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    ad_storage: cookies.advertising ? 'granted' : 'denied',
    analytics_storage: cookies.analysis ? 'granted' : 'denied',
    ad_personalization: cookies.advertising ? 'granted' : 'denied'
  })
  if (!cookies.analysis) return
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', googleTagManagerId)
  gtm = window.dataLayer
}

function isAvailable() {
  return !!gtm
}

function mapProducts(products) {
  return products.map(product => {
    return {
      id: product.id,
      item_id: product.id, // recommended name by google
      name: product.name,
      item_name: product.name, // recommended name by google
      quantity: product.quantity,
      price: lastUtils.round(product.finalPrice / 100)
    }
  })
}

function mapItems(products) {
  return products.map(product => ({
    item_id: product.id,
    item_name: product.name,
    quantity: product.quantity,
    price: lastUtils.round(product.finalPrice / 100)
  }))
}

async function checkoutCompleted({
  orderId,
  locationName,
  products,
  totalPrice,
  deliveryFee,
  taxRate,
  currencyCode,
  promotionCode
}) {
  gtm.push({
    event: 'purchase',
    ecommerce: {
      currency: currencyCode,
      transaction_id: orderId,
      value: lastUtils.round(totalPrice / 100),
      tax: lastUtils.round((totalPrice - totalPrice / (1 + taxRate)) / 100),
      shipping: lastUtils.round(deliveryFee / 100),
      coupon: promotionCode,
      items: mapItems(products),
      currencyCode: currencyCode,
      purchase: {
        actionField: {
          id: orderId,
          affiliation: locationName,
          revenue: lastUtils.round(totalPrice / 100),
          tax: lastUtils.round((totalPrice - totalPrice / (1 + taxRate)) / 100),
          shipping: lastUtils.round(deliveryFee / 100),
          coupon: promotionCode
        },
        products: mapProducts(products)
      }
    }
  })
}

async function addProductToCart({ product, currencyCode }) {
  gtm.push({
    event: 'addToCart',
    ecommerce: {
      add: {
        products: mapProducts([product])
      }
    }
  })
  gtm.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: currencyCode,
      value: lastUtils.round((product.finalPrice * (product.quantity || 1)) / 100),
      items: mapItems([product])
    }
  })
}

async function removeProductFromCart({ product }) {
  gtm.push({
    event: 'removeProductFromCart',
    ecommerce: {
      add: {
        products: mapProducts([product])
      }
    }
  })
}

async function beginCheckout({ products, totalPrice, currencyCode, promotionCode }) {
  gtm.push({
    event: 'checkout',
    ecommerce: {
      checkout: {
        products: mapProducts(products)
      }
    }
  })
  gtm.push({
    event: 'begin_checkout',
    ecommerce: {
      currency: currencyCode,
      value: lastUtils.round(totalPrice / 100),
      coupon: promotionCode,
      items: mapItems(products)
    }
  })
}

async function userLoggedIn() {
  gtm.push({
    event: 'login'
  })
}

async function userSignedUp() {
  gtm.push({
    event: 'signUp'
  })
}

async function itemViewed({ item }) {
  gtm.push({
    event: 'productClick',
    ecommerce: {
      click: {
        products: mapProducts([item])
      }
    }
  })
}

async function bookingOnGoing() {
  gtm.push({
    event: 'booking_on_going'
  })
}

async function bookingDone() {
  gtm.push({
    event: 'booking_done'
  })
}

export default {
  checkoutCompleted,
  isAvailable,
  addProductToCart,
  removeProductFromCart,
  beginCheckout,
  userLoggedIn,
  userSignedUp,
  itemViewed,
  bookingOnGoing,
  bookingDone,
  load
}
